import { SellerType } from '@kijiji/generated/graphql-types'

export const getNumericUserId = (userId: string): number => {
  const numericUserId = parseInt(userId.replace(`${SellerType.Commercial}_`, ''))

  return numericUserId
}
